/** 
 * 微信分享工具
 * @Time 2021-08-02 17:47:32
 * @Author nanfeng
 */

const wx = window.jWeixin || require('weixin-js-sdk');
import Constant from '../config/constant'

/**
 * 初始化微信jssdk设置
 */
export const wxSetup = (config) => {
    wx.config({
        debug: config.debug,
        appId: config.appId,
        timestamp: config.timestamp,
        nonceStr: config.nonceStr,
        signature: config.signature,
        jsApiList: config.jsApiList || ['updateAppMessageShareData', 'updateTimelineShareData', 'scanQRCode']
    })
}

/**
 * 微信支付方法
 * 获取微信加签信息
 * @param{data}:获取的微信加签
 * @param{cb}:成功回调
 */
export const wxShare = (config, share_params, callback) => {
    console.log('wxShare config, share_params', config, share_params)
    wx.config({
        debug: config.debug,
        appId: config.appId,
        timestamp: config.timestamp,
        nonceStr: config.nonceStr,
        signature: config.signature,
        jsApiList: config.jsApiList || ['updateAppMessageShareData', 'updateTimelineShareData', 'scanQRCode']
    })
    wx.ready(function() {

        if (share_params.icon && share_params.icon.indexOf('http://qiniu') > -1) {
            share_params.icon = share_params.icon + Constant.IMAGE_CROP_OPTIONS;
        }
        console.log('share_params---->', share_params);

        wx.updateAppMessageShareData({
            title: share_params.title, // 分享标题
            desc: share_params.desc, // 分享描述
            link: share_params.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: share_params.icon, // 分享图标
            success: function(res) {
                callback && callback(res)
            }
        })

        wx.updateTimelineShareData({
            title: share_params.title, // 分享标题
            link: share_params.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: share_params.icon, // 分享图标
            success: function(res) {
                callback && callback(res)
            }
        })
    })
    wx.error((err) => {
        console.log(err)
    })
}

/**
 * 微信扫码
 * @param{data}:获取的微信加签
 * @param{cb}:成功回调
 */

export const wxScanQrcode = (options, callback) => {
    wx.scanQRCode({
        desc: '请扫描优惠券核销码进行核销',
        needResult: options.needResult || 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: options.scanType || ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
            callback && callback(res)
        },
        error: function(res) {
            if (res.errMsg.indexOf('function_not_exist') > 0) {
                alert('版本过低请升级')
            }
        }
    });
}


export const wxOpenAddress = (callback) => {
    wx.openAddress({
        success: function (res) {
          var userName = res.userName; // 收货人姓名
          var postalCode = res.postalCode; // 邮编
          var provinceName = res.provinceName; // 国标收货地址第一级地址（省）
          var cityName = res.cityName; // 国标收货地址第二级地址（市）
          var countryName = res.countryName; // 国标收货地址第三级地址（国家）
          var detailInfo = res.detailInfo; // 详细收货地址信息
          var nationalCode = res.nationalCode; // 收货地址国家码
          var telNumber = res.telNumber; // 收货人手机号码
          callback && callback(res);
        }
      });
}


export const wxHideMenu = (data) => {
    wx.hideMenuItems({
        menuList: data || [] // 要隐藏的菜单项
    });
}